mcWeb.checkoutFooterView = new function () {

	this.events = {
	}

	this.vm = function (id) {
        var self = this;
		this.id = "#" + id;
        this.conditionsStatus = {
            isFunctionalConditionAccepted: ko.observable(false),
            acceptDocuments: ko.observableArray([]),
            usageArea: 3,
            refCondVm: null
        };

        this.isOrderRefRequired = false;
        
        this.load = function (data, settings) {
            PubSub.subscribe(mcWeb.conditions.events.onAcceptChange, function (evt, conditionStatus) {
                if (self.conditionsStatus.usageArea == conditionStatus.usageArea) {

                    if (conditionStatus.functionalConditionIsAccepted === null) {
                        self.conditionsStatus.isFunctionalConditionAccepted(true);
                    }
                    else {
                        self.conditionsStatus.isFunctionalConditionAccepted(conditionStatus.functionalConditionIsAccepted);
                    }
                    self.conditionsStatus.acceptDocuments(conditionStatus.acceptDocuments);
                    self.conditionsStatus.refCondVm = conditionStatus.vm;
                }
            });
            PubSub.subscribe(mcWeb.cart.events.onOrderRefReqChange, function (evt, isOrderRefRequired) {
                self.isOrderRefRequired = isOrderRefRequired;

                var el = jQuery('#McPaymentAddOrderbottom');

                if (self.isOrderRefRequired) {
                    el.tooltip('enable');
                    el.tooltip('show');
                    el.blur();
                } else {
                    el.tooltip('hide');
                    el.tooltip('disable');
                }       

            });
        };
        
        this.insertOrder = function (source) {
            if (self.isOrderRefRequired) {
                return;
            }

            var condsForProcessing = {
                isFunctionalConditionAccepted: self.conditionsStatus.isFunctionalConditionAccepted,
                acceptDocuments: self.conditionsStatus.acceptDocuments(),
                usageArea: self.conditionsStatus.usageArea
            };

            if (self.conditionsStatus == null || self.conditionsStatus.acceptDocuments == null || self.conditionsStatus.acceptDocuments().length <= 0) {
                condsForProcessing.isFunctionalConditionAccepted(true);
                if (source === 'vipps')
                    return true;
                mcWeb.checkout.insertOrder(condsForProcessing);
                return;
            }

            if (self.conditionsStatus.isFunctionalConditionAccepted()) {
                if (source === 'vipps')
                    return true;
                mcWeb.checkout.insertOrder(condsForProcessing);
            }
            else {
                if (self.conditionsStatus.refCondVm !== null) {
                    if (self.conditionsStatus.refCondVm.highlightRequired("checkoutconditions")) {
                        mcWeb.validation.qTipActionShowClickHide(self.id + " #McPaymentAddOrderbottom",
                            jQuery(".langtext-conditions-required").length > 0 ? jQuery(".langtext-conditions-required")[0].innerText : "");
                    }
                }               
            }
        };
	};
};
